var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 41,
    viewBox: "0 0 46 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 12.6562C45.5 19.1109 41.8125 25.7343 34.5417 32.3577C31.2401 35.3629 27.6452 38.0203 23.8125 40.2889C23.5635 40.4274 23.2841 40.5 23 40.5C22.7159 40.5 22.4365 40.4274 22.1875 40.2889C21.2917 39.7827 0.5 27.8226 0.5 12.6562C0.5 9.99989 1.32547 7.41091 2.85947 5.25599C4.39348 3.10108 6.55825 1.48948 9.04715 0.649475C11.5361 -0.190526 14.2229 -0.216341 16.7271 0.575686C19.2313 1.36771 21.4259 4.62495 23 6.75C24.5741 4.62495 26.7687 1.36771 29.2729 0.575686C31.7771 -0.216341 34.4639 -0.190526 36.9528 0.649475C39.4417 1.48948 41.6065 3.10108 43.1405 5.25599C44.6745 7.41091 45.5 9.99989 45.5 12.6562Z",
    fill: "#F22E6C",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.807dc49cba016467b8410a432f964492.svg";
export { ForwardRef as ReactComponent };